<template>
  <div class="sticky top-0 w-full z-[2147483000] bg-semantic-inverse-surface-light h-[4rem] drop-shadow-sm-1">
    <div class="flex flex-row flex-nowrap items-center justify-between h-full mx-4">
      <div class="h-full" :class="{'w-20 flex justify-end':!isDashboardPage, 'w-12 flex-none justify-start':isDashboardPage}">
        <AtomsButtonBack
          v-if="!isDashboardPage"
          class="my-auto"
          @click="goBack"
        />
        <NuxtLink
          v-else
          to="/dashboard/account-settings/"
        >
          <MoleculesNavProfile
            class="max-w-12"
            icon-only
            dropdown-position="left"
            icon-position="left"
            :has-background-when-active="false"
            :show-dropdown="false"
          />
        </NuxtLink>
      </div>
      <div class="w-64 flex-1 hidden xxxs:flex justify-center">
        <nuxt-link
          v-if="isDashboardPage"
          to=""
          class="flex mx-auto h-full">
          <NuxtImg
            height="28"
            width="167"
            class="min-w-[9rem] max-w-[9rem] xs:max-w-unset xs:min-w-[10.4375rem] lg:w-auto m-auto"
            src="/images/cc-logo-white-text.svg"
            alt="Compare Club"
          />
        </nuxt-link>
      </div>
      <div v-if="isDashboardPage" class="w-20 flex-none h-full flex justify-end">
        <ul class="flex items-center h-full w-full justify-between">
          <MoleculesNavNotification v-if="enableContentCardNotifications" class="float-right my-auto h-full"/>
          <atoms-menu-item
            id="pwa_intercom_launcher"
            padding="none"
            theme="global-navbar"
            class="menu-other min-w-8 flex justify-center"
            :has-background-when-active="false"
          >
            <NuxtImg
              src="/icons/chat-rounded.svg"
              alt="notifications"
              width="21"
              height="21"
              class="mx-auto"
            />
          </atoms-menu-item>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'OrganismsNavPwaMobileMenu'
})
const { enableContentCardNotifications } = useRuntimeConfig().public
const route = useRoute()
const router = useRouter()
const { $bus } = useNuxtApp()
const isDashboardPage = computed(() => {
  return ['dashboard','dashboard-quotes','dashboard-rewards','dashboard-perks'].includes(route.name)
})
const vaultStore = useVaultStore()
const goBack = () => {
  if (vaultStore.isInlineEdit) {
    router.push('/dashboard/').then(() => {
      vaultStore.resetInlineEdit()
    })
    return
  }

  const step = parseInt(route?.params?.step)

  if(step === 2 && vaultStore.vaultFormData?.product_type && route?.path?.includes('energy')) {
    router.push('/dashboard/')
    return
  }
  if(step === 1 && route?.path?.includes('/vault/form/')) {
    router.push('/dashboard/')
    return
  }
  if(route.name === 'dashboard-login') {
    const psRegistration = useState('psRegistration')
    if(psRegistration){
      $bus.emit('reset-login',true)
    }
  } else if (route.name === 'dashboard-vault-product-details'){
    router.push('/dashboard/')
  } else if (window?.history?.length > 1) {
    router.back()
  } else {
    location.reload()
  }
}
</script>
